import { Container, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function Loader({ className = '' }) {
    const { t } = useTranslation();

    return (
        <Container className={`${className} d-flex justify-content-center align-items-center`}>
            <Spinner animation="border" role="status">
                <span className="visually-hidden">{t('app.loading')}</span>
            </Spinner>
        </Container>
    )
}

export default Loader;